import { FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

export const VoucherMessage = (
  <FormattedMessage {...commonMessages.applyAVoucher} />
);
